import { ACCENT, MUTED, type IllustrationProps } from './types';

/**
 * IllustrationDisplayCases — empty-state art for glass display cases.
 *
 * Depicts: a two-tier glass display case on legs with cards visible behind
 * the front pane, framed in the accent colour to signal a public surface.
 *
 * Resource: display cases. Shell: any.
 */
export function IllustrationDisplayCases({ size = 120, className, style }: IllustrationProps) {
  const h = (size * 90) / 120;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 120 90"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <ellipse cx="60" cy="82" rx="40" ry="3" stroke={MUTED} strokeWidth={1.5} />
      {/* frame */}
      <rect x="22" y="18" width="76" height="56" rx="2" stroke={ACCENT} strokeWidth={1.5} />
      {/* shelf */}
      <line x1="22" y1="46" x2="98" y2="46" stroke={ACCENT} strokeWidth={1.5} />
      {/* legs */}
      <line
        x1="28"
        y1="74"
        x2="28"
        y2="80"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <line
        x1="92"
        y1="74"
        x2="92"
        y2="80"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      {/* top shelf cards */}
      <rect x="30" y="24" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      <rect x="46" y="24" width="12" height="18" rx="1" stroke={ACCENT} strokeWidth={1.2} />
      <rect x="62" y="24" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      <rect x="78" y="24" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      {/* bottom shelf cards */}
      <rect x="30" y="52" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      <rect x="46" y="52" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      <rect x="62" y="52" width="12" height="18" rx="1" stroke={ACCENT} strokeWidth={1.2} />
      <rect x="78" y="52" width="12" height="18" rx="1" stroke={MUTED} strokeWidth={1.2} />
      {/* glass shine */}
      <line
        x1="34"
        y1="22"
        x2="42"
        y2="38"
        stroke={MUTED}
        strokeWidth={1}
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  );
}
